import React from 'react';
import { withErrorBoundary } from '@nile/components';

const hexToUnicode = (hex) => {
  const isValidCodePoint = Number.isInteger(hex) && hex >= 0 && hex <= 0x10ffff;
  if (isValidCodePoint) {
    return String?.fromCodePoint(parseInt(hex, 16));
  } else {
    return hex;
  }
};

const checkIsEmoji = (str) => {
  // A regex to match emojis. Note: This may not be exhaustive and might require updates.
  const emojiRegex = /([\u203C-\u3299]|[\uDC00-\uDFFF])+$/;
  return emojiRegex.test(str);
};

const getEmojiFromUnicode = (emoji) => {
  if (emoji) {
    const isEmoji = checkIsEmoji(emoji);
    if (isEmoji) {
      return emoji;
    } else {
      // To display unicode as emojis in html.
      if (emoji?.includes('-')) {
        // For emojis with skin tone
        const [baseEmojiHex, skinToneHex] = emoji.split('-');
        return hexToUnicode(baseEmojiHex) + hexToUnicode(skinToneHex);
      } else if (emoji?.includes('+')) {
        const [prefix, emojiData] = emoji.split('+');
        return hexToUnicode(emojiData);
      } else {
        // For emojis without skin tone
        return hexToUnicode(emoji);
      }
    }
  }
};

const EmojiRender = (props) => {
  const { emoji, size = 'md' } = props;

  const displayEmoji = getEmojiFromUnicode(emoji);

  const className = ['emoji-render', size, props?.className]
    .filter(Boolean)
    .join(' ');

  return (
    <div id="emoji-render" className={className}>
      {displayEmoji}
    </div>
  );
};

export default withErrorBoundary(EmojiRender);
